import React from "react";
import icon from "../../../assests/solutionImages/medicalAlertimg/phoneimg.svg";


function MedicalalertTheme({card}) {
  console.log(card);

  const getFormattedAddress = () => {
    const address = card?.data?.contactInfo?.address;
    if (!address) return '';

    const parts = [];
    if (address.line1) parts.push(address.line1);
    if (address.line2) parts.push(address.line2);

    const cityStateParts = [];
    if (address.city) cityStateParts.push(address.city);
    if (address.state) cityStateParts.push(address.state);

    if (cityStateParts.length > 0) {
      parts.push(cityStateParts.join(", "));
    }

    if (address.country) parts.push(address.country);
    if (address.zipCode) parts.push(address.zipCode);

    return parts.join(" - ");
  };

  return (
    <div className="flex md:py-4 justify-center bg-gray-400">
      <div className="flex max-w-[393px] min-h-screen text-white overflow-y-auto scrollbar-hide lg:p-3 bg-white">
        <div className="text-black w-full p-3 rounded-md">
          {card?.data?.isProfileVisible && card?.profileImage && (
            <div className="flex justify-center items-center rounded-lg p-2">
              <img
                src={card.profileImage}
                alt="Profile"
                className="w-24 h-24 rounded-full object-cover"
              />
            </div>
          )}

          <div className="text-center py-4">
            <h2 className="text-3xl font-bold break-words">{card?.data?.name || card?.name}</h2>
            <p className="text-gray-600 break-all">{card?.data?.heading}</p>
            {card?.data?.subHeading && (
              <p className="text-gray-800 font-semibold break-all">{card?.data?.subHeading}</p>
            )}
          </div>

          <div className="grid grid-cols-1 gap-2 text-white">
            {card?.data?.aboutSection && (
              <div className="flex flex-col justify-center items-center bg-customGray rounded-2xl max-w-[393px] p-4">
                <p className="text-custom-gradient text-xl text-center font-bold break-all">
                  {card?.data?.aboutSection?.title}
                </p>
                <p className="text-gray-500 break-all">{card?.data?.aboutSection?.description}</p>
              </div>
            )}

            {card?.data?.medicalEmergencyInfo?.isVisible && (
              <div className="bg-customGray border-none p-4 rounded-2xl">
                {card?.data?.medicalEmergencyInfo?.isTitleDescriptionVisible && (
                  <div className="flex flex-col justify-center break-words items-center w-full space-y-2 mb-4">
                    <p className="text-custom-gradient text-xl break-words font-bold text-center w-full">
                      {card?.data?.medicalEmergencyInfo?.title}
                    </p>
                    <p className="text-custom-gradient text-xl font-bold text-center break-words w-full">
                      {card?.data?.medicalEmergencyInfo?.subTitle}
                    </p>
                  </div>
                )}

                <div className="lg:grid grid-cols-1 lg:gap-2">
                  {card?.data?.medicalEmergencyInfo?.details?.map((detail, index) => (
                    <React.Fragment key={detail?.id || index}>
                      <div className="grid grid-cols-2 pt-4 gap-2 max-w-full">
                        <p className="text-sm text-gray-400 break-all">{detail?.label}</p>
                        <p className="text-sm text-white break-all text-end">{detail?.value}</p>
                      </div>
                      {index < card?.data?.medicalEmergencyInfo?.details?.length - 1 && (
                        <div className="h-[1px] w-full bg-gray-100"></div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            )}

            {card?.data?.contactInfo && (
              <div className="bg-customGray border-none p-4 rounded-2xl">
                <div className="flex">
                  <h2 className="text-white text-lg font-semibold flex items-center gap-2 py-4">
                    <div className="flex-shrink-0">
                      <img src={icon} alt="" />
                    </div>
                    <p className="text-custom-gradient font-bold text-xl break-all flex-1">
                      {card?.data?.contactInfo?.title}
                    </p>
                  </h2>
                </div>
                <div className="lg:space-y-4">
                  {card?.data?.contactInfo?.emergencyContacts?.map((contact, index) => (
                    <React.Fragment key={contact.id || index}>
                      <div className="pt-2">
                        <p className="text-sm text-gray-400 break-words">{contact?.label}</p>
                        <a
                          href={`tel:${contact?.value}`}
                          className="text-sm break-all text-white hover:underline"
                        >
                          {contact?.value}
                        </a>
                      </div>
                      <div className="h-[1px] lg:w-full bg-gray-100 mt-1"></div>
                    </React.Fragment>
                  ))}

                  {card?.data?.contactInfo?.email && (
                    <>
                      <div className="pt-2">
                        <p className="text-sm text-gray-400">E-mail</p>
                        <a
                          href={`mailto:${card?.data?.contactInfo?.email}`}
                          className="text-sm text-white hover:underline break-all"
                        >
                          {card?.data?.contactInfo?.email}
                        </a>
                      </div>
                      <div className="h-[1px] lg:w-full bg-gray-100 mt-1"></div>
                    </>
                  )}

                  {card?.data?.contactInfo?.address && (
                    <div className="pt-2">
                      <p className="text-sm text-gray-400 break-all">{card?.data?.contactInfo?.address?.label}</p>
                      <p className="text-sm text-white break-all">{getFormattedAddress()}</p>
                    </div>
                  )}
                </div>
              </div>
            )}

            {card?.data?.contactInfo?.isFloatingButtonEnabled && (
              <div className="fixed bottom-8 right-8">
                <button
                  className="bg-custom-gradient text-white rounded-full p-4 shadow-lg"
                  onClick={() => {
                    if (card?.data?.contactInfo?.emergencyContacts?.length > 0) {
                      window.location.href = `tel:${card?.data?.contactInfo?.emergencyContacts[0]?.value}`;
                    }
                  }}
                >
                  {card?.data?.contactInfo?.floatingButtonText}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MedicalalertTheme;